module.exports = __webpack_public_path__ + "img/3.19744dc0.png";